import { api } from './api';
import { ArtifactType, CreateArtifactType, UpdateArtifactType } from '../types/artifactTypes';

export const artifactTypeService = {
  getAll: async (): Promise<ArtifactType[]> => {
    const response = await api.get('/artifact-types');
    return response.data;
  },

  getById: async (id: string): Promise<ArtifactType> => {
    const response = await api.get(`/artifact-types/${id}`);
    return response.data;
  },

  create: async (data: CreateArtifactType): Promise<ArtifactType> => {
    const response = await api.post('/artifact-types', data);
    return response.data;
  },

  update: async (id: string, data: UpdateArtifactType): Promise<ArtifactType> => {
    const response = await api.put(`/artifact-types/${id}`, data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/artifact-types/${id}`);
  },

  clearCache: (): void => {
    // This service doesn't have caching, but we keep the method for compatibility
    // The actual caching is in services/api/artifactTypeService.ts
    // If this service is used, we can implement caching here if needed
  },
};
